// extracted by mini-css-extract-plugin
export default {"container":"Bandwidth_container__Xj6Ib","progressBar":"Bandwidth_progressBar__YTrlf"};